export const RELEVANCE_SORT_FIELD_NAME = 'relevance';
